import React from 'react'
import { Box, Tooltip, Absolute } from 'pcln-design-system'
import styled from 'styled-components'
import { InformationOutline } from 'pcln-icons'
import { PriceGuidanceTooltipText } from './constants'

const TooltipWrapper = styled(Absolute)`
  display: none;
  max-width: 400px;
`

const InfoAreaWrapper = styled(Box)`
  height: 18px;
  &:hover {
    & > ${TooltipWrapper} {
      display: inline-block;
    }
  }
`

const StyledInfoIcon = styled(InformationOutline)`
  height: 18px;
`

export default function InfoArea() {
  return (
    <InfoAreaWrapper ml={'-18px'}>
      <StyledInfoIcon width={'18px'} />
      <TooltipWrapper width={1} zIndex={2} top={42} right={6} pl={3}>
        <Tooltip bg='background.darkest' color='white' bottom right width={1}>
          {PriceGuidanceTooltipText}
        </Tooltip>
      </TooltipWrapper>
    </InfoAreaWrapper>
  )
}
